import { XMarkIcon } from '@heroicons/react/20/solid';
import { ReceiptPercentIcon, CircleStackIcon, BuildingLibraryIcon, HomeIcon, CurrencyEuroIcon, ArchiveBoxArrowDownIcon } from '@heroicons/react/24/outline';
import { TransferIcon, BuyIcon, SellIcon } from '../../icons/remoteAssets';

export default function buildBlueTransactionOptions({ category, t, accountsConnectedToThisOne, transactions, loanAccountsForRepaymentTagging = [] }) {
  const transactionsAmount = transactions.length;
  const options = [];
  const connectedCategories = new Set(accountsConnectedToThisOne.map((acc) => acc.category));

  if (category === 'deposits') {
    options.push({
      id: null,
      Icon: XMarkIcon,
      name: t('labels.noLabel.long'),
      nextLevel: false,
      requiresPositiveAmount: true,
      requiresNegativeAmount: true,
    });

    // transfers are linked to a particular transaction, so only show if there is a single transaction selected
    if (transactionsAmount === 1) {
      options.push({
        id: 'investment-transfer',
        Icon: TransferIcon,
        name: t('labels.investment-transfer.long'),
        nextLevel: true,
        requiresPositiveAmount: true,
        requiresNegativeAmount: true,
      });
    }

    if (transactionsAmount === 1 && loanAccountsForRepaymentTagging.length > 0) {
      options.push({
        id: 'investment-loanRepayment',
        Icon: ArchiveBoxArrowDownIcon,
        name: t('labels.investment-loanRepayment.long'),
        nextLevel: true,
        requiresNegativeAmount: true,
      });
    }

    if (accountsConnectedToThisOne.length > 0) {
      // fees and sale are linked to a particular transaction, so only show if there is a single transaction selected
      if (transactionsAmount === 1) {
        options.push({
          id: 'investment-fees',
          Icon: BuildingLibraryIcon,
          name: t('labels.investment-fees.long'),
          nextLevel: true,
          requiresNegativeAmount: true,
        });

        options.push({
          id: 'investment-sale',
          Icon: SellIcon,
          name: t('labels.investment-sale.long'),
          nextLevel: true,
          requiresPositiveAmount: true,
        });

      }

      options.push({
        id: 'investment-costs',
        Icon: CurrencyEuroIcon,
        name: t('labels.investment-costs.long'),
        nextLevel: true,
        requiresNegativeAmount: true,
      });

      if (!connectedCategories.has('loans')) {
        options.push({
          id: 'investment-purchase',
          Icon: BuyIcon,
          name: t('labels.investment-purchase.long'),
          nextLevel: false,
          requiresNegativeAmount: true,
        });
      }
    }

    if (connectedCategories.has('deposits')) {
      options.push({
        id: 'investment-interest',
        Icon: ReceiptPercentIcon,
        name: t('labels.investment-interest.long'),
        nextLevel: true,
        requiresPositiveAmount: true,
      });
    }

    if (connectedCategories.has('realEstate')) {
      options.push({
        id: 'investment-rent',
        Icon: HomeIcon,
        name: t('labels.investment-rent.long'),
        nextLevel: true,
        requiresPositiveAmount: true,
      });
    }

    if (connectedCategories.has('stocks')) {
      options.push({
        id: 'investment-dividend',
        Icon: CircleStackIcon,
        name: t('labels.investment-dividend.long'),
        nextLevel: true,
        requiresPositiveAmount: true,
      });
    }

    if (connectedCategories.has('loans')) {
      options.push({
        id: 'investment-payout',
        Icon: ArchiveBoxArrowDownIcon,
        name: t('labels.investment-payout.long'),
        nextLevel: false,
        requiresPositiveAmount: true,
      });
    }

    if (connectedCategories.has('pension')) {
      options.push({
        id: 'investment-contribution',
        Icon: BuyIcon,
        name: t('labels.investment-contribution.long'),
        nextLevel: true,
        requiresNegativeAmount: true,
      });

      options.push({
        id: 'investment-pension',
        Icon: ReceiptPercentIcon,
        name: t('labels.investment-pension.long'),
        nextLevel: true,
        requiresPositiveAmount: true,
      });
    }
  }

  return options;
}
